module.exports = __webpack_public_path__ + "static/media/settings.b29d9210.svg";


//////////////////
// WEBPACK FOOTER
// ./src/settings.svg
// module id = 79
// module chunks = 0